import { api } from '@epcbuilder/lib/utils';
import { ContactUsFormData } from '@/models/contact';

export const postContactUs = async (data: ContactUsFormData) => {
  await api.post('/contact/contactus', data);
};
